export const publicImage = (file) => `${process.env.PUBLIC_URL}/${file}`;

export const WEDDING_IMAGES = {
  hero: "gallery-shrine-performers-group.jpeg",
  groomEntry: "gallery-street-procession-artists.jpeg",
  reception: "gallery-peacock-hall-group.jpeg",
  ceremony: "gallery-flower-arch-ceremony.jpeg",
  ensemble: "gallery-kombu-ensemble-group.jpeg",
  night: "gallery-may-night-performance.jpeg",
  temple: "gallery-temple-shrine-group.jpeg",
};

export const CLASSES_IMAGES = {
  hero: "gallery-training-session-march.jpeg",
};

export const MELAM_IMAGES = {
  hero: "gallery-temple-shrine-group.jpeg",
  showcase: "gallery-kombu-ensemble-group.jpeg",
  night: "gallery-may-night-performance.jpeg",
};

export const FUSION_IMAGES = {
  hero: "praana-beats.jpg",
  praana: "praana-beats.jpg",
};
